import React from 'react';

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/fontawesome-free-solid';
import ToggleButton from 'react-toggle-button';

import { FormGroup, Label } from 'reactstrap';
import Input from 'react-validation/build/input';

import './ConfirmDialog.css';

let toogle=false;

const DeleteConfirm = (props) => (
  
  <Modal className="confirmDialogModal" isOpen={props.isOpen} toggle={props.toggle} >
    <div className="confirmDialog">
      <span onClick={props.toggle} className="closeModalBtn">
        <FontAwesomeIcon icon={faTimes} />
      </span>
      <ModalHeader>Você tem certeza ?</ModalHeader>
      <ModalBody>
        <p className="m-0">Tem certeza de que deseja excluir este item?</p>
      </ModalBody>
      <ModalFooter className="pt-4">
        <Button className=" btn2-default px-5" onClick={props.confirm}>{props.t("Yes")}</Button>{' '}
        <Button className=" btn2-default px-5" onClick={props.toggle}>{props.t("No")}</Button>
      </ModalFooter>
    </div>
  </Modal>);

const RecordStream = (props) => (

  <Modal className="confirmDialogModal" isOpen={props.isOpen} toggle={props.toggle} >
    <div className="confirmDialog">
      <span onClick={props.toggle} className="closeModalBtn">
        <FontAwesomeIcon icon={faTimes} />
      </span>
      <ModalHeader>Broadcast Stream</ModalHeader>
      <ModalBody>
        <p className="m-0">Are you sure you want to {(props.isLiveAppActive)?'STOP':'START' } stream broadcast ?</p>
        <p></p>
        {
          (!props.isLiveAppActive)?(
           <div> <p className="m-0">
           <span style={{float: 'left', lineHeight: 1, marginRight: '10px' ,marginBottom :'0!important'}}>Record stream:</span> 
           {/* <input type="text" name="recordingName" id="recordingName" className="form-control"/> */}
           <ToggleButton value={props.toggleBtnState || false}
                 onToggle={props.toggleRecordingButton}/></p>
                 <p></p></div> 
          ):null
        }
       
         {
            (props.toggleBtnState && !props.isLiveAppActive)?(<p>Recording Name: <input type="text" name="recordingName" id="recordingName" className="form-control" onChange={props.updateRecordingName}/></p>):null
         }

      </ModalBody>
      <ModalFooter className="pt-4">
        <Button className="btn btn-rounded btn-outline-primary btn-stats px-5" onClick={()=>props.broadcastStream(props.appType)}>Yes</Button>{' '}
        <Button className="btn btn-rounded btn-outline-primary btn-stats px-5" onClick={props.toggle}>No</Button>
      </ModalFooter>
    </div>
  </Modal>);

const SocialLogout = (props) => (
  <Modal className="confirmDialogModal" isOpen={props.isOpen} toggle={props.toggle} >
    <div className="confirmDialog">
      <span onClick={props.toggle} className="closeModalBtn">
        <FontAwesomeIcon icon={faTimes} />
      </span>
      <ModalHeader>Are you sure ?</ModalHeader>
      <ModalBody>
        <p className="m-0">Are you sure you wish to logout ?</p>
      </ModalBody>
      <ModalFooter className="pt-4">
        <Button className="btn btn-rounded btn-outline-primary btn-stats px-5" onClick={props.confirm}>Yes</Button>{' '}
        <Button className="btn btn-rounded btn-outline-primary btn-stats px-5" onClick={props.toggle}>No</Button>
      </ModalFooter>
    </div>
  </Modal>
);

const ConfirmDialog = (props) => {
  
  if (props.type === 'delete') {
    return <DeleteConfirm isOpen={props.isOpen} toggle={props.toggle} confirm={props.confirm} t = {props.t}/>;
  } else if (props.type === 'recording'){
    return <RecordStream isOpen={props.isOpen} toggle={props.toggle} confirm={props.confirm} broadcastLive={props.broadcastLive} toggleRecordingButton={props.toggleRecordingButton} toggleBtnState={props.toggleBtnState} isLiveAppActive={props.isLiveAppActive} broadcastStream={props.broadcastStream} updateRecordingName = {props.updateRecordingName} appType={props.appType}/>;
  } else {
    return <SocialLogout isOpen={props.isOpen} toggle={props.toggle} confirm={props.confirm}/>;
  }
};

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/ConfirmDialog/ConfirmDialog.js